import { getConfig } from '../config/environment';

// Use runtime environment detection to switch between dev and prod APIs
const config = getConfig();
const API_BASE_URL = config.apiUrl;

export interface OrgUser {
  user_id: string;
  tenant_id: string;
  email: string;
  name?: string;
  role?: string;
  is_admin?: boolean;
}

class UsersService {
  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const token = localStorage.getItem('auth_token');
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }

  async listUsers(): Promise<OrgUser[]> {
    // Admin users API (tenant inferred from token)
    return this.request<OrgUser[]>(`/api/v1/admin/users`);
  }
}

export const usersService = new UsersService();


